<template>
  <div class="slider_ranges" >
    <svg width="100%" height="100%">


        <g  v-for="(item, i) in data"  :key="i">
          <text
                  y="14"
                  :x="item.x"
                  :text-anchor="item.align"
                  :style="annotation_txt_style"
          >{{item.label}}</text>

          <circle
                  r="4"
                  :cx="item.x"
                  cy="28"
                  class="dot"
          ></circle>
        </g>




    </svg>

  </div>
</template>

<script>
   /**
    * NOTE, the parent element must have css "position: relative" for this to position correctly
    * Note also that this is tightly coupled to the logic of the covidModel.vue component
    */
   export default {
      name: "SliderLabels",
      props: {
         labels: Array, //{key: {x, label}}, note that x is in pixels not in the slider's coordinate system
         device: String,
      },
      computed:{
         data(){

            let ans = [];
            for (let k in this.labels ){
               let tmp = this.labels[k];
               if (tmp.align === undefined)
                  tmp.align = 'middle';
               ans.push(tmp)
            }
            return ans;
         },

         annotation_txt_style(){
            if (this.device === 'mobile')
               return "font-size:xx-small";
            else
               return "font-size:x-small";
         },
      }
   }
</script>


<style scoped lang="scss">
  .slider_ranges{
    position: absolute; /* Sit on top of the page content */
    /*display: none; !* Hidden by default *!*/
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /*background-color: rgba(0,0,0,0.5); !* Black background with opacity *!*/
    z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */

    .dot{
      fill: #a9a9a9;
    }
  }

</style>